import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@src/core/store';

export interface UiState {
  screenWidth?: number;
  isRequestTimeout: boolean;
}

const initialState: UiState = {
  screenWidth: typeof window === 'object' ? window.innerWidth : undefined,
  isRequestTimeout: false,
};

// Reducers

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setScreenWidth: (state: UiState, action: PayloadAction<number>) => {
      state.screenWidth = action.payload;
    },
    setRequestTimeout: (state: UiState, action: PayloadAction<boolean>) => {
      state.isRequestTimeout = action.payload;
    },
  },
});

// Selectors

export const uiStateSelector = (state: RootState) => state.ui;
export const isRequestTimeoutSelector = (state: RootState) => state.ui.isRequestTimeout;

// Actions

export const { setScreenWidth, setRequestTimeout } = uiSlice.actions;

export default uiSlice.reducer;
